"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoricalFarm = void 0;
const GisField_1 = __importDefault(require("./GisField"));
const Acreage_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Acreage"));
const Field_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/modules/models/Field"));
class Farm {
    constructor(config) {
        this.id = config.id;
        this.name = config.name;
        this.created_at = config.created_at;
        this.client_name = config.client_name;
        this.client_code = config.client_code;
        this.total_fields = config.total_fields;
        this.total_extension = config.total_extension;
        this.preferred_unit = config.preferred_unit;
        this.gis_fields = config.gis_fields || [];
        this.geodata = config.geodata;
        this.date = config.date;
        this.active = config.active;
        this.has_results = config.has_results;
        this.eBeCrop_compatible = config.eBeCrop_compatible;
        this.eBeCrop_ready = config.eBeCrop_ready;
        this.quote_status = config.quote_status;
        this.gis_area_id = config.gis_area_id;
        this.last_completed_project = config.last_completed_project;
        this.last_proposal = config.last_proposal;
        this.auto_quote = config.auto_quote;
        this.crops = config.crops;
        this.farm_crops = config.farm_crops;
        this.gis_fields_ids = config.gis_fields_ids;
        this.fillAcreageInFields();
        this.has_gis_area_assigned = config.has_gis_area_assigned;
    }
    setFieldsGeodata(geodataItems) {
        geodataItems.forEach((geo) => {
            const fieldIx = this.gis_fields.findIndex((f) => f.id === geo.gis_field_id);
            if (fieldIx !== -1) {
                this.gis_fields[fieldIx].setGeodata(geo.geodata);
            }
        });
    }
    setGeodata(g) {
        this.geodata = g;
    }
    async fetchFieldsGeodata() {
        try {
            if (this.fields.every((gf) => gf.geodata.length === 0)) {
                const url = `/farm/${this.id}/gis-fields/geodata`;
                const request = await fetch(url);
                const response = await request.json();
                this.setFieldsGeodata(response);
            }
        }
        catch (e) {
            console.log(e);
        }
    }
    async fetchGeodata() {
        try {
            const url = `/farm/${this.id}/geodata`;
            const request = await fetch(url);
            const response = await request.json();
            this.setGeodata(response.geodata);
        }
        catch (e) {
            console.log(e);
        }
    }
    fillAcreageInFields() {
        this.gis_fields.forEach((g) => {
            if (g.geodata.length > 0) {
                g.acreage = g.calculateAcreage(this.preferred_unit);
            }
        });
    }
    get fields() {
        return this.gis_fields;
    }
    get configurationFields() {
        return this.parseGisFieldsIntoConfigurationFields();
    }
    get acreage() {
        return new Acreage_1.default(this.total_extension, this.preferred_unit);
    }
    get locked() {
        return !!(this.has_results || this.has_gis_area_assigned);
    }
    get cropLabel() {
        var _a, _b, _c, _d, _e, _f;
        if (this.farm_crops) {
            if (((_a = this.farm_crops) === null || _a === void 0 ? void 0 : _a.length) === 1) {
                return this.farm_crops[0].name;
            }
            else if (((_b = this.farm_crops) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                return 'MultiCrop';
            }
            else {
                return 'No Crop';
            }
        }
        else if (this.crops) {
            if (((_c = this.crops) === null || _c === void 0 ? void 0 : _c.length) === 1) {
                return this.crops[0].name;
            }
            else if (((_d = this.crops) === null || _d === void 0 ? void 0 : _d.length) > 0) {
                return 'MultiCrop';
            }
            else {
                return 'No Crop';
            }
        }
        else {
            if (((_e = this.cropsInvolved) === null || _e === void 0 ? void 0 : _e.length) === 1) {
                return this.cropsInvolved[0].name;
            }
            else if (((_f = this.cropsInvolved) === null || _f === void 0 ? void 0 : _f.length) > 0) {
                return 'MultiCrop';
            }
            else {
                return 'No Crop';
            }
        }
    }
    get farmName() {
        if (this.name.length < 50)
            return this.name;
        return this.name.substring(0, 48) + '...';
    }
    get cropColor() {
        var _a, _b, _c, _d, _e, _f;
        if (this.farm_crops) {
            if (((_a = this.farm_crops) === null || _a === void 0 ? void 0 : _a.length) === 1) {
                return this.farm_crops[0].color;
            }
            else if (((_b = this.farm_crops) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                return '#2A7346';
            }
            else {
                return '#AAA9A9';
            }
        }
        else if (this.crops) {
            if (((_c = this.crops) === null || _c === void 0 ? void 0 : _c.length) === 1) {
                return this.crops[0].color;
            }
            else if (((_d = this.crops) === null || _d === void 0 ? void 0 : _d.length) > 0) {
                return '#2A7346';
            }
            else {
                return '#AAA9A9';
            }
        }
        else {
            if (((_e = this.cropsInvolved) === null || _e === void 0 ? void 0 : _e.length) === 1) {
                return this.cropsInvolved[0].color;
            }
            else if (((_f = this.cropsInvolved) === null || _f === void 0 ? void 0 : _f.length) > 0) {
                return '#2A7346';
            }
            else {
                return '#AAA9A9';
            }
        }
    }
    get cropsInvolved() {
        return this.fields
            .map((f) => f.crop)
            .filter((crop, index, self) => self.findIndex((c) => c.name === crop.name) === index);
    }
    findConfigurationFieldFromGisField(g) {
        return this.configurationFields.find((f) => f.id === g.id);
    }
    findGisFieldFromConfigurationField(f) {
        return this.fields.find((g) => g.id === f.id);
    }
    setFieldAsEditing(field) {
        // Find original Field
        const activeFieldIx = this.gis_fields.findIndex((g) => g.id === field.id);
        // Init edition in original Field
        this.gis_fields[activeFieldIx].initEdition();
        // New Active
        this.gis_fields[activeFieldIx].name = field.fieldName;
        this.gis_fields[activeFieldIx].crop = field.crop;
        this.gis_fields[activeFieldIx].metadata = field.advancedMetadata;
        this.gis_fields[activeFieldIx].geodata = field.geodata;
    }
    undoFieldEdition(field) {
        const activeFieldIx = this.gis_fields.findIndex((g) => g.id === field.id);
        this.gis_fields[activeFieldIx].cancelEdition();
    }
    parseConfigurationFieldIntoGisField(f) {
        var _a, _b, _c, _d, _e, _f;
        return new GisField_1.default({
            id: f.id,
            gfId: f.gfId,
            name: f.fieldName,
            geodata: f.geodata,
            metadata: {
                extension: {
                    value: f.size,
                    unit: f.sizeUnit
                },
                soil_type: ((_a = f === null || f === void 0 ? void 0 : f.advancedMetadata) === null || _a === void 0 ? void 0 : _a.soil_type) || '',
                plant_year: ((_b = f === null || f === void 0 ? void 0 : f.advancedMetadata) === null || _b === void 0 ? void 0 : _b.plant_year) || '',
                variety: ((_c = f === null || f === void 0 ? void 0 : f.advancedMetadata) === null || _c === void 0 ? void 0 : _c.variety) || '',
                density: {
                    value: (_e = (_d = f === null || f === void 0 ? void 0 : f.advancedMetadata) === null || _d === void 0 ? void 0 : _d.density) === null || _e === void 0 ? void 0 : _e.value,
                    unit: f === null || f === void 0 ? void 0 : f.sizeUnit
                },
                practices: ((_f = f === null || f === void 0 ? void 0 : f.advancedMetadata) === null || _f === void 0 ? void 0 : _f.practices) || {
                    artificial_irrigation: {
                        enabled: false
                    },
                    biodynamic_practices: {
                        enabled: false
                    },
                    management_practices: []
                }
            },
            crop: f.crop,
            editionData: (f === null || f === void 0 ? void 0 : f.editionData) || null
        });
    }
    parseSingleGisFieldIntoConfigurationField(gf) {
        gf.acreage = gf.calculateAcreage(this.preferred_unit);
        return new Field_1.default({
            id: gf.id,
            gfId: gf.gfId,
            fieldName: gf.name,
            geodata: gf.geodata,
            farmId: this.id,
            farmName: this.name,
            size: gf.acreage.value,
            sizeUnit: gf.acreage.unit,
            crop: gf.crop,
            managementPractice: null,
            advancedMetadata: gf.metadata,
            origin: '',
            projection: '',
            metadata: [{
                    columnName: '',
                    columnValue: -1,
                }],
            quoteId: -1,
            editionData: gf === null || gf === void 0 ? void 0 : gf.editionData,
            provider: '',
            providerFieldId: ''
        });
    }
    parseGisFieldsIntoConfigurationFields() {
        return this.fields.map((gf) => {
            gf.acreage = gf.calculateAcreage(this.preferred_unit);
            return new Field_1.default({
                id: gf.id,
                gfId: gf.gfId,
                fieldName: gf.name,
                geodata: gf.geodata,
                farmId: this.id,
                farmName: this.name,
                size: gf.acreage.value,
                sizeUnit: gf.acreage.unit,
                crop: gf.crop,
                managementPractice: null,
                advancedMetadata: gf.metadata,
                origin: '',
                projection: '',
                metadata: [{
                        columnName: '',
                        columnValue: -1,
                    }],
                quoteId: -1,
                editionData: gf === null || gf === void 0 ? void 0 : gf.editionData,
                provider: 'setup-varda',
                providerFieldId: gf.vardaFieldId
            });
        });
    }
    updateField(f) {
        const ix = this.gis_fields.findIndex((gf) => gf.id === f.id);
        f.calculateAcreage(this.preferred_unit);
        if (ix !== -1) {
            this.gis_fields[ix] = f;
            this.gis_fields[ix].finishEdition();
        }
    }
    async downloadPDF() {
        const url = `/data/results/farm/pdf/${this.id}`;
        const link = document.createElement('a');
        link.href = url;
        document.body.appendChild(link);
        window.open(url);
    }
}
exports.default = Farm;
class HistoricalFarm {
    constructor(obj) {
        this.times = obj.times;
        this.farmHistory = obj.farmHistory;
    }
}
exports.HistoricalFarm = HistoricalFarm;
